import * as msgpack from '@msgpack/msgpack';
import { Base64 } from 'js-base64';

export function encode(data: unknown): string {
    return Base64.fromUint8Array(msgpack.encode(data), true);
}

export function decode(data: string): unknown {
    try {
        return msgpack.decode(Base64.toUint8Array(data));
    } catch {
        return undefined;
    }
}
